var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "m-2" },
    [
      _c("div", { staticClass: "btn-group float-right" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-sm btn-info",
            attrs: { title: _vm.$t("pivotCreateTemplate") },
            on: {
              click: function($event) {
                return _vm.createTemplate()
              }
            }
          },
          [_c("i", { staticClass: "fas fa-save" })]
        ),
        _vm._v(" "),
        _vm.templates && _vm.templates.templates
          ? _c(
              "button",
              {
                staticClass: "btn btn-sm btn-info",
                attrs: { title: _vm.$t("pivotTemplates") },
                on: {
                  click: function($event) {
                    return _vm.openSelectTemplateModal()
                  }
                }
              },
              [_c("i", { staticClass: "fas fa-file" })]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "clearfix mb-2" }),
      _vm._v(" "),
      _c("div", [
        _c(
          "ul",
          { staticClass: "list-group" },
          [
            _vm._l(_vm.firstXTemplates, function(template) {
              return _c(
                "li",
                {
                  key: template.template.name,
                  staticClass: "list-group-item c-pointer",
                  on: {
                    click: function($event) {
                      return _vm.onTemplateSelected(template.template)
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(template.template.name) +
                      "\n                "
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "visible",
                          rawName: "v-visible",
                          value: template.own,
                          expression: "template.own"
                        }
                      ],
                      staticClass: "badge badge-primary"
                    },
                    [_c("i", { staticClass: "fa fa-lock" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "visible",
                          rawName: "v-visible",
                          value: template.shared,
                          expression: "template.shared"
                        }
                      ],
                      staticClass: "badge badge-secondary"
                    },
                    [_c("i", { staticClass: "fa fa-users" })]
                  )
                ]
              )
            }),
            _vm._v(" "),
            _vm.moreThanXTemplatesAvailable
              ? _c(
                  "li",
                  {
                    staticClass: "list-group-item c-pointer",
                    on: { click: _vm.openSelectTemplateModal }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$t("pivot.template.moreTemplatesAvailable")
                        ) +
                        "\n            "
                    )
                  ]
                )
              : _vm._e()
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("create-template-modal", {
        ref: "createTemplateModal",
        on: { created: _vm.onTemplateCreated }
      }),
      _vm._v(" "),
      _c("select-template-modal", {
        ref: "selectTemplateModal",
        attrs: {
          templates: _vm.templates,
          templatesSharedOwn: _vm.templatesSharedOwn,
          templatesSharedOther: _vm.templatesSharedOther
        },
        on: { selected: _vm.onTemplateSelected, deleted: _vm.onTemplateDeleted }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }